import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { AlertTriangle, TrendingUp, Package } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";

export function DashboardAlerts({ alerts, COLORS }) {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.5 }}>
      <Card className="border-border/50 h-full">
        <CardContent className="p-3 md:p-5">
          <div className="flex items-center justify-between mb-3 md:mb-4">
            <h2 className="text-base md:text-lg font-semibold flex items-center gap-2">
              <AlertTriangle className="w-5 h-5" style={{ color: COLORS.warning }} />
              Alertes stock
            </h2>
            {alerts.length > 0 && (
              <Badge style={{ backgroundColor: COLORS.negative }} className="text-white">{alerts.length}</Badge>
            )}
          </div>
          {alerts.length > 0 ? (
            <div className="space-y-3">
              {alerts.slice(0, 4).map((alert) => (
                <div key={alert.id} className="flex items-center justify-between p-3 rounded-lg border"
                  style={{ borderColor: `${COLORS.warning}40`, backgroundColor: `${COLORS.warning}08` }}>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${COLORS.warning}20` }}>
                      <Package className="w-4 h-4" style={{ color: COLORS.warning }} />
                    </div>
                    <div>
                      <p className="font-medium text-sm truncate max-w-[140px]">{alert.name}</p>
                      <p className="text-xs text-muted-foreground">Seuil: {alert.low_stock_threshold}</p>
                    </div>
                  </div>
                  <Badge style={{ backgroundColor: COLORS.negative }} className="text-white text-xs">
                    {alert.quantity} restants
                  </Badge>
                </div>
              ))}
              {alerts.length > 4 && (
                <Link to="/products?filter=low_stock">
                  <Button variant="outline" size="sm" className="w-full mt-2">
                    Voir les {alerts.length - 4} autres alertes
                  </Button>
                </Link>
              )}
            </div>
          ) : (
            <div className="text-center py-8">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3" style={{ backgroundColor: `${COLORS.positive}15` }}>
                <TrendingUp className="w-6 h-6" style={{ color: COLORS.positive }} />
              </div>
              <p className="text-sm text-muted-foreground">Tous les stocks sont corrects</p>
            </div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}
